import * as React from 'react';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip, InputNumber, Row, Col, Upload, Icon, Collapse } from 'antd';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import TranslationDTO from 'src/models/generic/TranslationDTO';
import TextArea from 'antd/lib/input/TextArea';
import Languages, { Language } from 'src/constants/Languages';
import { UploadFile, UploadProps } from "antd/lib/upload/interface";
import { AntFormSimple, AntFormItems, AntFormRules } from "src/utils/formUtil/Form";
import { NameOf } from "src/utils/NameOf";
import ObjectUtil from "src/utils/ObjectUtil";
import { AddEditQuestionResponseDTO, AddEditQuestionResponseTranslationDTO, CultureFileUploadDTO } from "src/models/frontend/admin/AddEditQuestionResponseDTO";


interface ActivityQuestionResponseFormReturn extends AddEditQuestionResponseDTO {
    fileList: CultureFileUploadDTO[];
}

interface ActivityQuestionResponseFormProps {
    currentValues: AddEditQuestionResponseDTO;
    onSubmit: (values: ActivityQuestionResponseFormReturn) => void;
    onCancel: () => void;
}

interface ActivityQuestionResponseFormState extends AddEditQuestionResponseDTO {
    selectedCultureId: number;
    fileList: CultureFileUploadDTO[];
    isLoading: boolean;
}

class ActivityQuestionResponseForm extends React.Component<ActivityQuestionResponseFormProps, ActivityQuestionResponseFormState> {
    constructor(props: ActivityQuestionResponseFormProps) {
        super(props);
        bindAllOfThis(this, ActivityQuestionResponseForm.prototype);

        this.state = {
            activityQuestionId: 0,
            activityQuestionResponseId: 0,
            displayOrder: 0,
            weight: 0,
            selectedCultureId: 0,
            isSurvey: false,
            isCorrect: false,
            translations: [],
            fileList: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.deriveStateFromProps(this.props);
    }

    componentWillReceiveProps(newProps: ActivityQuestionResponseFormProps) {
        if (newProps.currentValues !== this.props.currentValues) {
            this.deriveStateFromProps(newProps);
        }
    }

    private deriveStateFromProps(props: ActivityQuestionResponseFormProps) {
        // Update some state based on prop change
        let translations = props.currentValues.translations;
        if (translations.length === 0) {
            return this.setState({
                ...props.currentValues,
                fileList: Languages.All.filter(x => x.isAvailable).map<CultureFileUploadDTO>(x => {
                    return { cultureId: x.id, file: undefined };
                }),
                selectedCultureId: 1, // Default would normally be 0, but ehhhh
            });
        }
        this.setState({
            ...props.currentValues,
            fileList: translations.map<CultureFileUploadDTO>(x => {
                let newFile: UploadFile = undefined;
                if (x.imageFile != null) {
                    let uid = Math.floor(Math.random() * 10000);
                    newFile = {
                        uid: uid.toString(),
                        name: x.imageFile.fileName,
                        status: 'done',
                        thumbUrl: x.imageFile.azureFileUrl,
                    } as UploadFile;
                }
                return { cultureId: x.cultureId, file: newFile };
            }),
            selectedCultureId: translations[0].cultureId,
            isLoading: false
        }, () => {
            console.warn("this.state", this.state); // JB - Remove this console.warn
        });
    }

    onSubmit(values: AddEditQuestionResponseDTO) {
        console.warn("Valuies", values); // JB - Remove this console.warn
        // Values contains all values updated on the form. Merge those with what we have in state and return the result
        let merged = ObjectUtil.DeepMergeObjects(this.state, values);
        let output: ActivityQuestionResponseFormReturn = {
            ...merged,
            // This cleans up the clobbering that DeepMerge does as the values object contains some very interesting stuff in the fileList attribute
            fileList: this.state.fileList,
        };
        this.props.onSubmit(output);
    }

    onChange(values: AddEditQuestionResponseDTO) {
        // This is involved with the form validation
        let merged = ObjectUtil.DeepMergeObjects(this.state, values);
        this.setState({ ...merged });
    }

    onCancel() {
        this.props.onCancel();
    }

    renderSaveButton(): JSX.Element {
        let hasMissingTranslations = this.state.translations.some(x => x.text == null || x.text.length < 1);
        let submitButton = <AntFormItems.SubmitButton type="primary" loading={false} disabled={hasMissingTranslations} key="submitButton">
            <Translate id="admin.common.saveButton" />
        </AntFormItems.SubmitButton>;

        if (hasMissingTranslations) {
            return <Tooltip placement="bottom" title={<Translate id="admin.addEditActivityQuestionResponse.saveTooltip" />} arrowPointAtCenter>
                {submitButton}
            </Tooltip>;
        }

        return submitButton;
    }

    renderCollapse() {
        let panels = this.state.translations.map((translation: TranslationDTO, index: number) => {
            let culture = Languages.FindById(translation.cultureId);
            const props: UploadProps = {
                action: "",
                onRemove: (file) => {
                    // File will be the only file for the current language in fileList
                    let fileList = this.state.fileList;
                    fileList.find(x => x.cultureId === culture.id).file = undefined;
                    this.setState({
                        fileList: fileList,
                    });
                },
                beforeUpload: (file) => {
                    let fileList = this.state.fileList;
                    fileList.find(x => x.cultureId === culture.id).file = file;
                    this.setState({
                        fileList: fileList,
                    });

                    // Stop the actual file upload process, we will do that later
                    return false;
                },
                fileList: this.state.fileList.filter(x => x.cultureId === culture.id).map(x => x.file).filter(x => x),
                listType: "picture",
                accept: "image/x-png,image/gif,image/jpeg",
            };

            return <Collapse.Panel header={`${culture.name}`} key={`${index}`} style={{ display: "block" }}>
                <AntFormItems.Custom
                    uniqueId={`${NameOf<ActivityQuestionResponseFormState>("translations")}[${index}].${NameOf<AddEditQuestionResponseTranslationDTO>("text")}`}
                    label={<Translate id={`admin.addEditActivityQuestionResponse.${culture.code.toLowerCase()}`} />}
                    initialValue={translation.text}
                    key={`admin.addEditActivityQuestionResponse.${culture.code.toLowerCase()}`}
                    rules={[AntFormRules.Required(<Translate id="admin.common.requiredRule" />)]}
                >
                    <TextArea rows={4} autoComplete="off" />
                </AntFormItems.Custom>
                <AntFormItems.Custom
                    uniqueId={`${NameOf<ActivityQuestionResponseFormState>("translations")}[${index}].${NameOf<AddEditQuestionResponseTranslationDTO>("imageFile")}`}
                    label={<Translate id={`admin.addEditActivityQuestionResponse.${culture.code.toLowerCase()}`} />}
                    key={`admin.addEditActivityQuestionResponse.${culture.code.toLowerCase()}2`}
                >
                    <Upload {...props}>
                        <Button>
                            <Icon type="upload" /> Select File
                        </Button>
                    </Upload>
                </AntFormItems.Custom>
            </Collapse.Panel>;
        });
        return <Collapse key="translations-panel" defaultActiveKey={['0']} style={{ display: "table-caption" }}>{panels}</Collapse>;
    }

    render() {
        if (this.props.currentValues == null || this.props.currentValues.translations == null) {
            return null;
        }

        return <Row>
            <Col span={12}>
                <AntFormSimple onSubmit={x => this.onSubmit(x)} onChange={this.onChange} className="admin-form">
                    {this.renderCollapse()}

                    <AntFormItems.Input
                        uniqueId={NameOf<ActivityQuestionResponseFormState>("displayOrder")}
                        key={NameOf<ActivityQuestionResponseFormState>("displayOrder")}
                        label={<Translate id="admin.addEditActivityQuestionResponse.formItem2" />}
                        initialValue={this.state.displayOrder}
                        type={"number"}
                        rules={[AntFormRules.Required(<Translate id="admin.common.requiredRule" />)]}
                    />
                    <AntFormItems.Input
                        uniqueId={NameOf<ActivityQuestionResponseFormState>("weight")}
                        key={NameOf<ActivityQuestionResponseFormState>("weight")}
                        label={<Translate id="admin.addEditActivityQuestionResponse.formItem3" />}
                        initialValue={this.state.weight}
                        type={"number"}
                        rules={[AntFormRules.Required(<Translate id="admin.common.requiredRule" />)]}
                        visible={this.state.isSurvey}
                    />
                    <AntFormItems.Custom
                        uniqueId={NameOf<ActivityQuestionResponseFormState>("isCorrect")}
                        key={NameOf<ActivityQuestionResponseFormState>("isCorrect")}
                        label={<Translate id="admin.addEditActivityQuestionResponse.formItem4" />}
                        initialValue={this.state.isCorrect}
                    >
                        <Checkbox checked={this.state.isCorrect} />
                    </AntFormItems.Custom>

                    <div key="buttons">
                        {this.renderSaveButton()}
                        <Divider type="vertical" />
                        <AntFormItems.Button onClick={this.onCancel} key="backButton">
                            <Translate id="common.back" />
                        </AntFormItems.Button>
                    </div>
                </AntFormSimple>
            </Col>
        </Row>;
    }
}

export default ActivityQuestionResponseForm;
export { ActivityQuestionResponseFormReturn, ActivityQuestionResponseFormProps };



// WEBPACK FOOTER //
// ./src/pages/admin/forms/AddEditActivityQuestionResponseForm.tsx